import { AfterViewInit, Component, ElementRef, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { InputComponent } from "@shared/controls/input/input.component";
import { CustomFormValidators } from "@shared/validators/custom-form-validators";
import { emailValidatorMsg } from "@shared/validators/custom-form-validators-messages";
import { CommonModalFormComponent } from "@shared/components/commons/common-modal-form/common-modal-form.component";

@Component({
  selector: 'app-add-carbon-copy',
  standalone: true,
  imports: [
    CommonModalFormComponent,
    FormsModule,
    InputComponent,
    ReactiveFormsModule
  ],
  templateUrl: './add-carbon-copy.component.html',
  styleUrl: './add-carbon-copy.component.scss'
})
export class AddCarbonCopyComponent implements OnInit, AfterViewInit {
  @ViewChild('emailInput', { static: false }) emailInput!: ElementRef<InputComponent>
  @Output() confirm = new EventEmitter<string>();

  private fb: FormBuilder = inject(FormBuilder);
  private activeModal = inject(NgbActiveModal);

  form!: FormGroup
  protected readonly emailValidatorMsg = emailValidatorMsg;

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
    });
  }

  ngAfterViewInit(): void {
    if (this.emailInput) {
      const el = (this.emailInput.nativeElement as unknown as HTMLElement).querySelector('.input');
      if(el) {
        (el as HTMLElement).focus();
      }
    }
  }

  add(): void {
    const email = this.form.get('email')?.value as string;
    this.confirm.emit(email);
    this.activeModal.close();
  }

  close(): void {
    this.activeModal.close();
  }
}
